import { render } from "./FileInputButton.vue?vue&type=template&id=43adb03f&scoped=true"
import script from "./FileInputButton.vue?vue&type=script&lang=js"
export * from "./FileInputButton.vue?vue&type=script&lang=js"

import "./FileInputButton.vue?vue&type=style&index=0&id=43adb03f&scoped=true&lang=scss"
import "./FileInputButton.vue?vue&type=style&index=1&id=43adb03f&scoped=true&lang=css"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43adb03f"]])

export default __exports__